'use client'

import Script from 'next/script'
import { usePathname } from 'next/navigation'
import { useAuth } from '@/lib/auth/context'
import { ADSENSE_PUBLISHER, hasAdSensePublisher, isAdsPathBlocked } from '@/components/ads/config'
import { shouldShowAds } from '@/lib/ads/should-show-ads'

/**
 * Carrega o adsbygoogle.js — e só ele. Com Auto Ads ligado no painel do AdSense,
 * carregar o script já basta: o Google lê a página e coloca os anúncios nos
 * melhores lugares. Não empurramos nada nem definimos posições.
 *
 * Não carrega para quem está logado (shouldShowAds) nem em páginas de
 * conversão/conta/conteúdo fino (isAdsPathBlocked) — assim o Auto Ads nem tenta
 * rodar lá no carregamento direto/SEO.
 */
export function AdSenseScript() {
  const { user, isLoading } = useAuth()
  const pathname = usePathname()

  if (!hasAdSensePublisher()) return null
  if (isLoading) return null // espera auth pra não dar flash de script em sessão logada
  if (!shouldShowAds(user)) return null
  if (isAdsPathBlocked(pathname)) return null

  return (
    <Script
      id="adsense-client"
      async
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_PUBLISHER}`}
      crossOrigin="anonymous"
      strategy="afterInteractive"
    />
  )
}
